export const HELP_ARTICLE_HOME = 'https://help.justsift.com/en/';

export const HELP_LINKS = [
  { name: 'Kick-Off Guide', href: 'https://help.justsift.com/en/articles/3990510-kick-off-guide' },
  { name: 'Implementation', href: 'https://help.justsift.com/en/articles/3956499-implementation' },
  { name: 'Configuration', href: 'https://help.justsift.com/en/articles/3956516-configuration' },
  { name: 'Onboarding', href: 'https://help.justsift.com/en/articles/3953480-onboarding' },
];

export const LIST_SLIDE_KEY = 'list';
export const CHEERS_SLIDE_KEY = 'celebrate';
